"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerReducer = registerReducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _action_types = require("../../constants/action_types");
var _registration = require("../../types/registration");
var _defaultState = require("./defaultState");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function registerReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _defaultState.defaultState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _action_types.REGISTRATION_REGISTER_TYPE:
      return _objectSpread(_objectSpread({}, state), {}, {
        register: _objectSpread(_objectSpread({}, state.register), {}, {
          status: action.status,
          errorType: action.status === _registration.ERegisterStatus.Failed ? action.errorType : action.status === _registration.ERegisterStatus.Succeed ? undefined : state.register.errorType,
          error: action.status === _registration.ERegisterStatus.Failed ? action.error : action.status === _registration.ERegisterStatus.Succeed ? undefined : state.register.error
        })
      });
  }
  return state;
}